import { Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class InternalApprovalEntity extends TemporalEntity {
    static typeName = "InternalApprovalEntity";

    constructor() {
        super();
        this.makeObservable();
    }

    public internalApprovalEntityId: number = 0;

    @Rules.Required()
    @Rules.StringLength(80)
    public entityName: string = "";

    @Rules.Required()
    @Rules.StringLength(80)
    public alias: string = "";

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<InternalApprovalEntity>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.entityName) {
            return "New internal approval entity";
        } else {
            return this.entityName;
        }
    }
}